/* assign function is default function for mapping */
export const DEFAULT_FUNCTION = {
    key: 'assign',
    value: 'value'
};

export const DEFAULT_FUNCTION_DATABASE_VALUE = '';
